module.exports = __webpack_public_path__ + "static/smoothscroll-c2d3efc2d02a2443fb2dcb6cde1377cf.png";